module.exports = __webpack_public_path__ + "img/pic-1.3fa2a8bb.png";